var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"speaker",class:{ active: _vm.activeAudio.fileName === _vm.word },attrs:{"src":_vm.speakerIcon(),"alt":"speaker-icon"},on:{"click":function($event){$event.preventDefault();return _vm.player.word(_vm.word);}}})
}
var staticRenderFns = []

export { render, staticRenderFns }